
<div container>
  <student-amiram-tests #studentAmiramTests>
  </student-amiram-tests>

  <available-amiram-tests
    (onPayedNewAmiramTest)="onPayedNewAmiramTest()">
  </available-amiram-tests>
</div>
